import React from "react";
import {
    Grid,
    makeStyles,
    Card,
    Typography,
} from "@material-ui/core";
import MainScreen from "./templates/MainScreen";
import { useTranslation } from "react-i18next";
import HourglassFullIcon from "../components/svg/HourGlassIcon";
// Animation
import { easeQuadInOut } from "d3-ease";
import AnimatedProgressProvider from "../components/AnimatedProgressProvider";
import {
    CircularProgressbarWithChildren,
    buildStyles,
} from "react-circular-progressbar";
import "react-circular-progressbar/dist/styles.css";
import "../css/Hourglass.css";

const useStyles = makeStyles(() => ({
    loading: {
        width: "200px",
        height: "200px",
        marginTop: "calc(40% - 16px)",
        marginLeft: "auto",
        marginRight: "auto",
    },
    centerHorizontal: {
        marginLeft: "auto",
        marginRight: "auto",
    },
    fullHeight: {
        height: "100%",
    },
    textCenter: {
        textAlign: "center",
    },
    info: {
        position: "relative",
    },
    marginTop3: {
        marginTop: "3rem",
    },
}));

type GetReadyLoadingProps = {
    duration: number;
}

export default function GetReadyLoading({ duration }: GetReadyLoadingProps): JSX.Element {
    const classes = useStyles();
    const { t } = useTranslation();
    return (
        <MainScreen lower={false} back={false}>
            <Grid container direction="column" justify="space-around" classes={{ root: classes.fullHeight }}>
                <Card elevation={0} className={`${classes.centerHorizontal} ${classes.info}`}>
                    <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.textCenter}`}>
                        {t("get-ready")}
                    </Typography>
                    <div className={`${classes.loading}`}>
                        <AnimatedProgressProvider
                            valueStart={0}
                            valueEnd={100}
                            duration={duration}
                            easing={easeQuadInOut}
                            repeat
                        >
                            {(value: number) => (
                                <CircularProgressbarWithChildren
                                    value={value}
                                    strokeWidth={50}
                                    styles={buildStyles({
                                        pathTransition: "none",
                                        strokeLinecap: "butt",
                                        pathColor: "#333332",
                                        trailColor: "#d6d6d6",
                                    })}
                                >
                                    <HourglassFullIcon />
                                </CircularProgressbarWithChildren>
                            )}
                        </AnimatedProgressProvider>
                    </div>
                    <Typography variant="h3" className={`${classes.centerHorizontal} ${classes.textCenter} ${classes.marginTop3}`}>
                        3... 2... 1...
                    </Typography>
                </Card>
            </Grid>
        </MainScreen>
    );
}
